import { QuestionBase } from './question-base';

export class CheckboxQuestion <T extends boolean>extends QuestionBase<T> {
  controlType = 'checkbox';
}